import { Component, Input, input, output } from '@angular/core'

@Component({
  selector: 'aiomed-report-loader',
  imports: [],
  templateUrl: './report-loader.component.html',
  styleUrl: './report-loader.component.scss'
})
export class ReportLoaderComponent {
  @Input() loader: boolean | null = false
  readonly isDark = input<boolean>(false)
  readonly isMobile = input<boolean>(false)
  readonly emitClick = output<void>()

  ngOnInit(): void {}
}
